export const GET_AVALIBILITY_STATUS = '[Availability Status Action] Get Availability Status';
export const CONFIRMED_GET_AVALIBILITY_STATUS = '[Availability Status Action] Confirmed Get Availability Status';
